import _defineProperty from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

var _mapI18nErrorKeys;

import { CommonProto } from '@finam/txservices-auth';
import i18n from '../i18n/i18n';
var StatusCode = CommonProto.Code;
var mapI18nErrorKeys = (_mapI18nErrorKeys = {}, _defineProperty(_mapI18nErrorKeys, StatusCode.UNKNOWN, 'serverError'), _defineProperty(_mapI18nErrorKeys, StatusCode.PERMISSION_DENIED, 'permissionDenied'), _defineProperty(_mapI18nErrorKeys, StatusCode.RESOURCE_EXHAUSTED, 'limitExceed'), _defineProperty(_mapI18nErrorKeys, StatusCode.ABORTED, 'aborted'), _defineProperty(_mapI18nErrorKeys, StatusCode.UNAUTHENTICATED, 'unauthenticated'), _defineProperty(_mapI18nErrorKeys, StatusCode.ALREADY_EXISTS, 'alreadyExists'), _mapI18nErrorKeys);
export var createServiceError = function createServiceError(error) {
  return {
    code: error.code,
    message: error.message,
    details: error.details
  };
};
export var getServiceErrorMessage = function getServiceErrorMessage(lang, _ref, i18nChunkPath) {
  var code = _ref.code,
      message = _ref.message;
  var defaultKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : mapI18nErrorKeys[StatusCode.UNKNOWN];

  if (code === StatusCode.OK) {
    return null;
  }

  if (message && (!code || !mapI18nErrorKeys[code])) {
    return message;
  }

  var keyPrefix = (i18nChunkPath || '').replace(/\.$/, '');
  var key = "".concat(keyPrefix, ".").concat(mapI18nErrorKeys[code || StatusCode.UNKNOWN] || defaultKey);
  return i18n(lang)(key);
};